import update from 'immutability-helper';
import * as types from './types';

const initialState = {
  aiCustomModalVisible: false,
  manualCustomModalVisible: false,
  showVerifyDialog: false,
  config: {
    name: '',
    emails: '',
    alertType: '',
    alertList: null,
    state: 2, // default enabled state
    configId: null,
    partnerId: null,
    partnerName: '',
    defaultFields: [],
    alertConfig: {
      aiConfig: {
        severity: null,
        customFields: [],
      },
      maConfig: {
        priority: null,
        customFields: [],
      },
    },
    endPoint: null,
  },
};

const updateCustomModalVisibility = (type, state) => {
  if (type === 'ai') {
    return update(state, {
      aiCustomModalVisible: {
        $set: !state.aiCustomModalVisible,
      },
    });
  }
  if (type === 'manual') {
    return update(state, {
      manualCustomModalVisible: {
        $set: !state.manualCustomModalVisible,
      },
    });
  }
  return state;
};

const reducerMap = {};

reducerMap[types.TOGGLE_VERIFY_DIALOG] = state => update(state, {
  showVerifyDialog: {
    $set: !state.showVerifyDialog,
  },
});

reducerMap[types.UPDATE_CONFIG] = (state, action) => update(state, {
  config: {
    $merge: action.payload,
  },
});

// eslint-disable-next-line max-len
reducerMap[types.CHANGE_CUSTOMISATION_MODAL_VISIBILITY] = (state, action) => updateCustomModalVisibility(action.payload, state);

reducerMap[types.UPDATE_AI_CONFIG] = (state, action) => update(state, {
  config: {
    alertConfig: {
      aiConfig: {
        $set: action.payload,
      },
    },
  },
});

reducerMap[types.UPDATE_MANUAL_CONFIG] = (state, action) => update(state, {
  config: {
    alertConfig: {
      maConfig: {
        $set: action.payload,
      },
    },
  },
});

reducerMap[types.CLEAR_CONFIG] = state => update(state, {
  config: {
    $set: { ...initialState.config },
  },
});

export default (state = initialState, action) => (
  reducerMap[action.type] ? reducerMap[action.type](state, action) : state
);
